// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.filters', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./accessibility');
require('./audio_packet_format');
require('./boolean');
require('./boxcast_tv_link');
require('./boxcaster_key');
require('./boxcaster_name');
require('./branded_app_status');
require('./composite_standard');
require('./datespan');
require('./detected_pro_video_input');
require('./detected_video_input');
require('./facebook_live_settings');
require('./generic_rtmp_push_settings');
require('./hdmi_standard');
require('./high_frame_rate');
require('./label');
require('./mac-address');
require('./md5');
require('./metric_prefix');
require('./number_with_unit');
require('./order_address');
require('./periscope_settings');
require('./boxcast_flow_control');
require('./rtmp_push_channel_push_settings');
require('./sdi_heo_veo');
require('./sdi_link_rate');
require('./scoreboard_make_model');
require('./source');
require('./timespan');
require('./timestamp');
require('./tracking_link')
require('./transcoder_profile');
require('./twitter_settings');
require('./underscore_to_space');
require('./youtube_live_settings');

// View-specific directives
require('../views/dashboard/dashboard_filters');

export default module;


// WEBPACK FOOTER //
// ./filters/index.js